import { Button, ComponentStyle} from '@/imports-files/components/confirmation-modal';
import { AgencyModalStyle} from '@/imports-files/components/confirmation-modal';
import { FormModalStyle, Close } from "@/imports-files/components/common-modal/common-modal";
import { InfoModalStyle } from "@/imports-files/components/common-modal/common-modal";
import Modal from "./common-modal/modal";
import { useTranslation } from "@/imports-files/common/common";

export function AgencyAcceptRejectModal(props)
{

  let heightClass = props.heightClass ? props.heightClass : '';
  let widthClass = props.widthClass ? props.widthClass : '';
  let buttonwidth = props.buttonwidth ? props.buttonwidth : '';
  const {t} =useTranslation();
  return(

      <Modal
      type="form"
      heading= {t('modal:duplicate:heading')}
      filterWidth = {true}
      closeModal={(event) => {
        props.setAgencyAcceptReject({status: false});
      }}
      content={
        <>
        <div className={`${FormModalStyle.Modal__Container__ContentSection} mt30`}>
        <span className={AgencyModalStyle.ConfirmationModal__SubText}>{t('modal:duplicate:user')}: <span>{props.viewData.agency_user_name}</span></span>
        <span className={AgencyModalStyle.ConfirmationModal__SubText}>{t('modal:duplicate:agency')}: <span>{props.viewData.agency_name}</span></span>
        <span className={AgencyModalStyle.ConfirmationModal__SubText}>{t('modal:duplicate:job')}: <span>{props.viewData.job_title}</span></span>
        <span className={AgencyModalStyle.ConfirmationModal__SubText}>{t('modal:duplicate:candidate_name')}: <span>{props.viewData.candidate_name}</span></span>
        <span className={AgencyModalStyle.ConfirmationModal__SubText}>{t('modal:duplicate:date_submitted')}: <span>{props.viewData.date_submitted}</span></span>
        <span className={AgencyModalStyle.ConfirmationModal__NewText}>{t('modal:duplicate:confirmation_heading')}</span>
       </div>
       <div className={FormModalStyle.Modal__Container__ButtonSection}>
        <Button buttonstyle={`${FormModalStyle.secondarybtn}`}   onClick={() => {props.closeModal()}}> {props?.texts?.button1_text || t('modal:duplicate:decline')} </Button>
        <Button buttonstyle={`${FormModalStyle.primarybtn}`} onClick={() => {props.btnAction()}}> {props?.texts?.button2_text || t('modal:duplicate:accept')}</Button>
       </div>
       </>
      }
      />
        )
}

